import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Sliders } from "lucide-react";
import { usePollingResource } from "../hooks/usePollingResource";
import type { SystemOverview } from "../api/system";
import SystemMonitor from "../components/SystemMonitor";
import { PageHeader } from "../components/ui/Primitives";
import CockpitTabs from "../components/CockpitTabs";
import ResourceNotice from "../components/ResourceNotice";
import Control from "./Control";
import Alerts from "./Alerts";
import Logs from "./Logs";
import Risk from "./Risk";
import News from "./News";
import EconomicCalendar from "./EconomicCalendar";
import TossAuthCard from "../components/TossAuthCard";
import SaveTicker from "./SaveTicker";
import LLMIntelligence from "./LLMIntelligence";
import Models from "./Models";
import DataExport from "./DataExport";
import KisObservabilityCard from "../components/KisObservabilityCard";
import SupplyDemandCard from "../components/SupplyDemandCard";
import IntelligenceWorkbench from "../components/IntelligenceWorkbench";
const tabs = [{ id: 'status', label: '상태' }, { id: 'intelligence', label: '데이터·LLM 분석' }, { id: 'control', label: '제어' }, { id: 'alerts', label: '알림' }, { id: 'data', label: '자료' }, { id: 'logs', label: '로그' }, { id: 'risk', label: '리스크' }];
const dataTabs = [{ id: 'toss-auth', label: '토스 인증' }, { id: 'saveticker', label: 'SaveTicker' }, { id: 'news', label: '뉴스' }, { id: 'calendar', label: '경제 일정' }, { id: 'llm-intel', label: 'LLM' }, { id: 'models', label: '모델' }, { id: 'export', label: '내보내기' }, { id: 'observability', label: 'KIS·수급' }];
export default function Management() {
    const { tab, kind } = useParams();
    const [params] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const active = kind ? 'data' : tabs.some(t => t.id === tab) ? tab! : 'status';
    const requested = kind ?? params.get('sub');
    const sub = dataTabs.some(t => t.id === requested) ? requested! : 'saveticker';
    const changeData = (id: string) => { const next = new URLSearchParams(params); next.delete('sub'); navigate(`/management/data/${id}${next.size ? `?${next}` : ''}${location.hash}`); };
    return <div className="cockpit-page">
    <PageHeader icon={<Sliders size={22}/>} title="관리" description="실행 상태, 자료와 운용 제어"/>
    <CockpitTabs id="management" tabs={tabs} value={active} onChange={id => navigate(`/management/${id}${location.search}${location.hash}`)}/>
    <section id="management-panel" role="tabpanel" aria-labelledby={`management-${active}`}>
      {active === 'status' && <StatusTab />}{active === 'intelligence' && <IntelligenceWorkbench/>}{active === 'control' && <Control />}{active === 'alerts' && <Alerts />}{active === 'logs' && <Logs />}{active === 'risk' && <Risk />}
      {active === 'data' && <div className="cockpit-page"><CockpitTabs id="data" tabs={dataTabs} value={sub} onChange={changeData}/>
        <section id="data-panel" role="tabpanel" aria-labelledby={`data-${sub}`}>
          {sub === 'toss-auth' && <TossAuthCard/>}{sub === 'saveticker' && <SaveTicker />}{sub === 'news' && <News />}{sub === 'calendar' && <EconomicCalendar />}{sub === 'llm-intel' && <LLMIntelligence />}{sub === 'models' && <Models />}{sub === 'export' && <DataExport />}
          {sub === 'observability' && <div className="cockpit-page"><p className="notice-card">KIS·수급은 현재 C1 크립토 전략의 진입·축소 조건에 포함되지 않는 자문 관측입니다.</p><KisObservabilityCard advisoryOnly/><SupplyDemandCard /></div>}
        </section>
      </div>}
    </section>
  </div>;
}
function StatusTab() {
    const resource = usePollingResource<SystemOverview>('/overview', 15000);
    return <div className="cockpit-page">
    <div className="btn-row"><button className="btn-secondary" onClick={resource.refresh}>상태 새로고침</button></div>
    <ResourceNotice {...resource}/>
    <SystemMonitor data={resource.data} failed={!!resource.error} full/>
  </div>;
}
